export enum CustomerDocumentOrigin {
  Local = 'local',
  Remote = 'remote'
}
